import { Builder } from 'react-native-jala-orm/src/model/Builder';
import SyncableModel from './SyncableModel';

export default class Parameter extends SyncableModel {
    static name = 'Parameter'

    _fillable = [
      'id', 'parameter_category_id', 'code', 'name',
      'short_name', 'icon', 'unit', 'verified', 'number', 'query',
      'lowest_limit', 'low_limit', 'high_limit', 'highest_limit',
      'created_at', 'updated_at', 'deleted_at', 'synced_at',
    ]

    _casts = {
      highest_limit: 'float',
      high_limit: 'float',
      low_limit: 'float',
      lowest_limit: 'float',
      verified: 'bool',
      query: 'array',
    };

    static endpoint = '/parameters'

    static syncOnly = true

    static Measurement = SyncableModel

    static _boot() {
      super._boot();

      this.addGlobalScope('global', (query: Builder) => {
        query.whereNull(query.qualifyColumn('query'));
      });
    }

    static syncAll(
      params = {}, sqlParams = [], cleanAfterSync = true,
      onSyncProgressUpdate = undefined, onError = undefined
    ) {
      return super.syncAll(params, sqlParams, cleanAfterSync, onSyncProgressUpdate, onError)
        .finally(() => (new this.Measurement())); // Boot Measurement
    }
}
